import { Controller } from '@hotwired/stimulus'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { createElement, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

export default class ReactController extends Controller {
  createComponent() {
    throw new Error('subclasses must implement createComponent()')
  }

  connect() {
    const component = this.createComponent()
    const componentWithI18n = createElement(StrictMode, null, createElement(I18nProvider, { i18n }, component))

    this.root = createRoot(this.element)
    this.root.render(componentWithI18n)
  }

  disconnect() {
    this.root.unmount()
  }
}
